/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_AuthorizedInputs */

const en_not_authorized = /** @type {(inputs: Not_AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not authorized`)
};

const nl_not_authorized = /** @type {(inputs: Not_AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet geautoriseerd`)
};

/**
* | output |
* | --- |
* | "Not authorized" |
*
* @param {Not_AuthorizedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const not_authorized = /** @type {((inputs?: Not_AuthorizedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_AuthorizedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_not_authorized(inputs)
	return en_not_authorized(inputs)
});